<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" [ngClass]="formLayout">
  <div class="form-fields">
    <ng-container *ngFor="let field of fieldsConfig">
      <div *ngIf="field.isVisible" class="form-field" 
           [ngClass]="field.cssClass"
           [ngStyle]="{'width': (field.width ? field.width + '%' : '100%')}">
        
        <span *ngIf="isFieldRequired(field)" class="required-asterisk">*</span>
        
        <!-- Campos de texto -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.TEXT) || field.dataType.equals(VarType.EMAIL) || field.dataType.equals(VarType.PASSWORD)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <input 
            matInput 
            [type]="field.dataType.value" 
            [formControlName]="field.fieldName"
            [placeholder]="field.placeholder || ''"
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>
        
        <!-- Campos numéricos -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.NUMBER)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <input 
            matInput 
            type="number" 
            [formControlName]="field.fieldName"
            [placeholder]="field.placeholder || ''"
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>
        
        <!-- Campo de moneda -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.CURRENCY)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <input 
            matInput 
            type="number" 
            [formControlName]="field.fieldName"
            [placeholder]="field.placeholder || ''"
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
          <span matPrefix>$&nbsp;</span>
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>
        
        <!-- Textarea -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.TEXTAREA)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <textarea 
            matInput 
            [formControlName]="field.fieldName"
            [placeholder]="field.placeholder || ''"
            rows="4"
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          ></textarea>
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>
        
        <!-- Checkbox -->
        <div *ngIf="field.dataType.equals(VarType.CHECKBOX)" class="checkbox-field">
          <mat-checkbox 
            [formControlName]="field.fieldName" 
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
            {{ field.fieldLabel }}
          </mat-checkbox>
          <mat-error *ngIf="hasError(field.fieldName, 'required')">
            Este campo es requerido
          </mat-error>
        </div>
        
        <!-- Radio buttons -->
        <div *ngIf="field.dataType.equals(VarType.RADIO)" class="radio-group">
          <label class="radio-label">
            {{ field.fieldLabel }}
            <span *ngIf="isFieldRequired(field)" class="required-asterisk">*</span>
          </label>
          <mat-radio-group 
            [formControlName]="field.fieldName" 
            class="radio-buttons" 
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
            <mat-radio-button *ngFor="let option of field.options" [value]="option.value">
              {{ option.label }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </div>
        
        <!-- Select dropdown -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.SELECT)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <mat-select 
            [formControlName]="field.fieldName" 
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
            <mat-option *ngFor="let option of field.options" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>

        <!-- Select dinamicos-->
        <!-- ✅ CORREGIDO: Campo SELECT único, con spinner y opción de agregar -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.SELECTDINAMIC)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>

          <!-- Spinner mientras carga opciones -->
          <mat-progress-spinner *ngIf="isLoadingSelect[field.fieldName]" mode="indeterminate" diameter="24"></mat-progress-spinner>

          <mat-select
            [formControlName]="field.fieldName"
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field) || isLoadingSelect[field.fieldName]">

            <!-- Opcion vacía -->
            <mat-option *ngIf="field.isRequired !== true" [value]="null"></mat-option>

            <!-- Opciones estáticas o desde servicio -->
            <mat-option *ngFor="let item of getSelectOptions(field)" [value]="getSelectValue(field, item)">
              {{ getSelectLabel(field, item) }}
            </mat-option>

            <!-- Opcion para abrir un Dialog personalizado -->
            <mat-option *ngIf="field.openDialogComponent" class="add-option" (click)="openCreateDialog(field)">
              <strong>+ Agregar Registro</strong>
            </mat-option>

          </mat-select>

          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>

        

        
        <!-- Date picker -->
        <mat-form-field *ngIf="field.dataType.equals(VarType.DATE)" appearance="outline" class="full-width">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <input 
            matInput 
            [matDatepicker]="picker" 
            [formControlName]="field.fieldName"
            [placeholder]="field.placeholder || ''"
            [required]="isFieldRequired(field)"
            [disabled]="isFieldDisabled(field)"
          >
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngFor="let errorMsg of getErrorMessages(field.fieldName)">
            {{ errorMsg }}
          </mat-error>
        </mat-form-field>
        <!-- Dentro del ngSwitchCase en tu formulario -->
        <ng-container [ngSwitch]="field.dataType.value">
        <!-- Caso para CHIPS - Versión para Angular 14 -->
        <mat-form-field *ngSwitchCase="'chips'" [style.width.%]="field.width" [ngClass]="field.cssClass">
          <mat-label>{{field.fieldLabel}}</mat-label>
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let item of formGroup.get(field.fieldName)?.value || []" 
                      (removed)="removeChip(field.fieldName, item)">
              {{item}}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="[13, 188]" 
                  (matChipInputTokenEnd)="addChip($event, field.fieldName)"
                  [disabled]="isFieldDisabled(field)"
                  placeholder="Añadir etiqueta...">
          </mat-chip-list>
        </mat-form-field>

        </ng-container>
      </div>
    </ng-container>
  </div>
  
  <div *ngIf="showBotons" class="form-actions">
    <button 
      *ngIf="showResetButton" 
      type="button" 
      mat-button 
      (click)="resetForm()"
      [disabled]="!canEdit"
    >
      {{ resetButtonText }}
    </button>
    <button 
      type="submit" 
      mat-raised-button 
      color="primary"
      [disabled]="formGroup.invalid || !canEdit"
    >
      {{ submitButtonText }}
    </button>
  </div>
</form>